module.exports = __webpack_public_path__ + "img/logo-header-en.2180c983.png";